<template>
<div class="HiddenDanger">
  <div class="mainContent" :style="styleObject">
    <div class="logHandlerArea handlerArea">
      <!-- <el-date-picker class="dateTimeRangePicker" v-model="dateTimeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-input class="scontent" placeholder="隐患标题|隐患内容" v-model="content" style="width:170px;"></el-input>
      <button class="primaryBtn" @click="searchLogs">搜索</button> -->
      <button class="primaryBtn" @click="delAll">批量删除</button>      
    </div>
    <div class="logContentShowArea" v-loading="loading">
      <div class="logContentArea">
        <div class="tableBox">
          <border-table :tableData="logData" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @selectionChange="handleSelectionChange" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
            <!-- <el-table-column type="index" label="序号" width="60"></el-table-column> -->
            <el-table-column type="selection" width="50" border></el-table-column>
            <el-table-column prop="dangerTitle" label="隐患标题" width="80"></el-table-column>
            <el-table-column prop="handleInfo" label="处理内容" min-width="400"></el-table-column>
            <el-table-column prop="" label="处理图片">
              <template slot-scope="scope" v-if="scope.row.dangerHandleThumbnail&&scope.row.dangerHandleOriginalPhoto">
                <div><img :src="baseUrlAddr+scope.row.dangerHandleThumbnail" alt="" style="cursor:pointer" @click="imgMask(scope.row.dangerHandleOriginalPhoto)"></div>
              </template>
            </el-table-column>
            <el-table-column prop="handlerNickName" label="处理人"></el-table-column>
            <el-table-column prop="createTime" label="处理时间" min-width="170"></el-table-column>
            <el-table-column prop="" label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="delClick(scope.row)" size="small" class="del">删除</el-button>
              </template>
            </el-table-column>
            <!-- <div class="hasNoData" v-if="noData">
            <div class="noDataImg"><img src="../../../../static/img/noData.png" alt=""></div>
            <p>暂无数据</p>
          </div> -->
          </border-table>
        </div>
      </div>
    </div>
  </div>
  <div class="imgMasking" v-if="showImg">
    <div class="closeBtn" @click="showImg = false"><i class="el-icon-circle-close" /></div>
    <div class="imgMask">
      <img :src="imgUrl" alt="">
    </div>
  </div>
</div>
</template>

<script>
var qs = require("qs");
import BorderTable from "@/components/common/BorderTable";
export default {
  components: {
    BorderTable,
  },
  data() {
    return {
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      noData: false,
      logType: "",
      dateTimeRange: [],
      tableMaxHeight: 0,
      searchInput: "",
      logData: [],
      styleObject: {
        height: ""
      },
      content: '',
      ip: '',
      imgUrl: '',
      showImg: false,
      checkDatas: [],
    };
  },
  created() {
    this.makeheight();
    this.queryLog();
    // if (this.getViewportSize.height > 768) {
    //   this.tableMaxHeight = this.getViewportSize.height - 290;
    // } else {
    //   this.tableMaxHeight = 486;
    // }
  },
  methods: {
    //图片放大
    imgMask(data) {
      this.imgUrl = this.baseUrlAddr + data
      this.showImg = true
    },
    //查询租户功能
    searchLogs() {
      let dateTimeRange = this.dateTimeRange || [];
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        1,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    //刷新数据
    refreshData() {
      let dateTimeRange = this.dateTimeRange || [];
      this.currentPage = 1;
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        1,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    getTime(date) {
      if (date) {
        let year = date.getFullYear(); //获取完整的年份(4位,1970-????)
        let month =
          date.getMonth() + 1 < 10 ?
          "0" + (date.getMonth() + 1) :
          date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        let datenow =
          date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //获取当前日(1-31)
        let day =
          date.getDay() == 0 ?
          "星期天" :
          date.getDay() == 1 ?
          "星期一" :
          date.getDay() == 2 ?
          "星期二" :
          date.getDay() == 3 ?
          "星期三" :
          date.getDay() == 4 ?
          "星期四" :
          date.getDay() == 5 ? "星期五" : "星期六"; //获取当前星期X(0-6,0代表星期天)
        let hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //获取当前小时数(0-23)
        let minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //获取当前分钟数(0-59)
        let seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //获取当前秒数(0-59)
        return (
          year +
          "-" +
          month +
          "-" +
          datenow +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      } else {
        return "";
      }
    },
    queryLog(operType, page, pageSize, content, ip) {
      this.loading = true;
      let params= {
            // startTime: startTime || "",
            // endTime: endTime || "",
            page: page || 1,
            pageSize: pageSize || 10,
            order: "desc",
            sort: "createTime",
            // content: content || "",
            // ip: ip || "",
            // method: operType || ""
          }
      this.request.get("/front/danger/handle/query",params)
        .then(rs => {
          console.log(rs);

          this.loading = false;
          if (rs.code == 200) {
            this.logData = rs.data;
            this.pagination.total = rs.total;
            this.noData = false;
            if (!rs.total) {
              this.noData = true;
            }
          } else {
            this.noData = true;
          }
        });
    },
    handleSizeChange(val) {
      let dateTimeRange = this.dateTimeRange || [];
      this.pagination.pageSize = val;
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        1,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    handleCurrentChange(val) {
      let dateTimeRange = this.dateTimeRange || [];
      this.currentPage = val;
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        this.pagination.currentPage,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleSelectionChange(data) { //多选
      // console.log(data)
      this.checkDatas = data
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.delete("/front/danger/handle/delete?dangerHandleIds=" + row.id).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              let num = ''
              if (this.pagination.total > 1) {
                num = (this.pagination.total - 1) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    delAll() {
      //批量删除
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选删除内容！")
      } else {
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push(this.checkDatas[i].id)
        }
        this.arry = arr
        console.log(this.arry)
        let params = {
          dangerHandleIds: this.arry.toString()
        }
        this.$confirm('此操作将永久删除内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.request.delete("/front/danger/handle/delete", params).then(res => {
            // console.log(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              let num = ''
              if (this.pagination.total > this.pagination.pageSize) {
                num = (this.pagination.total - this.checkDatas.length) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.HiddenDanger {
  // height: 100%;
  // overflow: hidden;
  position: relative;

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  .logHandlerArea {
    margin-bottom: 20px;
    overflow: hidden;

    .selectForm {
      float: left;
      width: 150px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .dateTimeRangePicker {
      float: left;
      width: 360px;
      height: 36px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .scontent {
      float: left;
      height: 36px;
    }

    .primaryBtn {
      float: left;
      height: 36px;
      vertical-align: middle;
      margin-left: 0;
    }

    .delSome {
      float: right;
      height: 36px;
      vertical-align: middle;
      margin-left: 0;
      padding: 0 10px;
    }
  }
   .del {
      background: #eaa13a;
      color: #fff;
    }
  .imgMasking {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;

    [class*=" el-icon-"],
    [class^=el-icon-] {
      font-size: 50px;
      cursor: pointer;
    }

    .closeBtn {
      position: absolute;
      top: 50px;
      right: 100px;
      font-size: 50px;
      color: #fff;
    }

    .imgMask {
      // width: 600px;
      height: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      // margin-top: -300px;
      // margin-left: -300px;
      transform: translate(-50%, -50%);
      background: #fff;

      img {
        // width: 100%;
        height: 100%;
      }
    }
  }
}
</style><style lang="scss">
.HiddenDanger {
  .logHandlerArea {
    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 150px;
      margin-right: 10px;

      .el-input {
        width: 150px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }
}
</style>
